module.exports = __webpack_public_path__ + "img/wx.9f7bafe0.jpg";